<template>
  <CardItemLimit :item="item" v-if="item.hasLimit" /> 
  <CardItemBase :item="item" v-else />
</template>

<script>
import CardItemBase from './CardItemBase';
import CardItemLimit from './CardItemLimit';

export default {
  props: ['item'],
  components: {
    CardItemBase,
    CardItemLimit,
  },
}
</script>

<style>
.pd__item {
  padding: 1em;
  width: 20%;
}

.pd .gutter {
  display: flex;
  flex-direction: column;
  height: 100%;
  border: solid 1px #ddd;
  border-radius: 5px;
  overflow: hidden;
}

.pd__name, .pd .img__inner, .pd__desc {
  margin: 10px;
}

.pd__name {
  height: 48px;
  font-size: 16px;
  font-weight: 100;
  line-height: 1.5;
}

.pd__desc--fast {
  align-self: flex-start;
  padding: 3px 5px;
  color: #fff;
  font-size: 13px;
  text-transform: uppercase;
  background-color: #cc0000;
  border-radius: 3px;
}

.pd__desc--price {
  color: red;
  font-size: 20px;
  font-weight: 600;
}

.pd__desc--gift {
  padding: 2px 5px;
  font-size: 14px;
  color: #f26591;
  align-self: flex-start;
  border: solid 1px #f26591;
  border-radius: 3px;
}

.pd__spec {
  height: 100%;
  padding-top: 50px;
  padding-bottom: 50px;
  text-align: center;
  color: #fff;
  background-color: #f26591;
}

.pd__spec .pd__name {
  height: auto;
}

.pd__spec .pd__desc {
  font-size: 22.5px;
}

</style>



// WEBPACK FOOTER //
// src/components/Card/CardItem.vue